export class Department {
    Dept;
    CDesc;
    EDesc;
    constructor() {
      this.Dept = "";
      this.CDesc = "";
      this.EDesc = "";
    }
  }
  


// WEBPACK FOOTER //
// ./src/model/Department.js